import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Membership from '../components/membership/Membership'
import {
  selectAccountProfile,
  selectKycProfile,
  selectMainProfile,
  selectStakingProfile,
  selectTokenProfile
} from '../store/selectors/common'
import { buildPerkUrl } from '../util/staking/perks.helpers'
import { openExternalUrl } from '../util/app/app.helpers'
import { isKycIncomplete } from '../util/kyc.helpers'
import { KYC_PROFILE_DISPATCH } from '../store/reducers/account/kyc'
import { changeKYCState } from '../store/actions/kyc'
import { DEFAULT_CONTAINER_STATE } from '../constants/containerStates'

const MembershipContainer = () => {
  const { t } = useTranslation()
  const mainProfile = useSelector(selectMainProfile)
  const tokenProfile = useSelector(selectTokenProfile)
  const stakingProfile = useSelector(selectStakingProfile)
  const accountProfile = useSelector(selectAccountProfile)
  const kycProfile = useSelector(selectKycProfile)

  const dispatch = useDispatch()

  const isKycNotSuccess = isKycIncomplete({
    status: kycProfile.status
  })

  const handleOpenPerk = useCallback((option) => {
    if (isKycNotSuccess) {
      dispatch(
        changeKYCState(KYC_PROFILE_DISPATCH.POPUP_STATE, {
          id: DEFAULT_CONTAINER_STATE.FEATURE_LOCKED
        })
      )
    } else {
      openExternalUrl(buildPerkUrl(option, accountProfile))
    }
  }, [])

  return (
    <Membership
      t={t}
      mainProfile={mainProfile}
      stakingProfile={stakingProfile}
      tokenProfile={tokenProfile}
      onOpenPerk={handleOpenPerk}
    />
  )
}

export default MembershipContainer
